// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-picker-opacity[data-v-946b77d8]{width:50px}.color-picker-hex[data-v-946b77d8]{width:100px;margin-right:5px}.color-picker-color[data-v-946b77d8]{width:40px;margin-right:5px;padding:3px;border:1px solid #aaa;background-clip:content-box}.color-picker[data-v-946b77d8]{width:200px}", ""]);
// Exports
module.exports = exports;
